// import InfoIcon from '../../../assets/images/circle-information.svg';
import './FavoritesSwapCardAlertComponent.scss';
// import { DEFAULT_LABELS, DEFAULT_LINKS } from './model';

export default function FavoritesSwapCardAlertComponent() {
	// const redirect = () => {
	// 	window.open(DEFAULT_LINKS.link, '_blank', 'noopener noreferrer');
	// 	console.log('triggered');
	// };
	return (
		<></>
		// <div className='favoritesLinkSwapCard'>
		// 	<div className='title'>
		// 		<img className='info-icon' src={InfoIcon} alt='Information Icon' />
		// 		{DEFAULT_LABELS.title}
		// 	</div>
		// 	<div className='description'>{DEFAULT_LABELS.description}</div>
		// 	<div className='login' onClick={redirect}>
		// 		<span className='login-text'>{DEFAULT_LABELS.button_text}</span>
		// 		<i className='ri-arrow-right-s-line line-icon'></i>
		// 	</div>
		// </div>
	);
}
